/* eslint-disable i18next/no-literal-string */
import { useEffect } from 'react';
import { useScript } from 'usehooks-ts';
import { getOneTrustConfig } from '../configuration/configuration';

export const useOneTrustScript = () => {
  const config = getOneTrustConfig();

  const status = useScript(config.scriptUrl, {
    removeOnUnmount: false
  });

  useEffect(() => {
    if (status === 'loading') {
      const element = document.querySelector(`script[src="${config.scriptUrl}"]`);
      element?.setAttribute('data-domain-script', config.domain);
      element?.setAttribute('nonce', 'hVwQrR81zYgVYWPaKcB273RdGfONtljskBEYaXJbRs');
      window.OptanonWrapper = () => {}; // needed as function is populated by script
    }
  }, [status]);
};
